<template>
  <ReferenceMultipleSelect
    v-model="destinationCountries"
    class="ma-0"
    label="Страна прибытия"
    resource="countries"
    @input="changeArrivalCountries"
  />
</template>

<script>
export default {
  computed: {
    destinationCountries: {
      get() {
        return this.$store.getters["routePlanning/destinationCountries"];
      },
      set(value) {
        return this.$store.commit(
          "routePlanning/setDestinationCountries",
          value,
        );
      },
    },
  },
  methods: {
    changeArrivalCountries(value) {
      this.$store.commit("routePlanning/setDestinationCountries", value);
      this.$store.commit("routePlanning/setFilterIsActive", true);
      this.$emit("input");
    },
  },
};
</script>
